import axios from 'axios'
import { UrlApi, authMail, authPass } from '../Keys'
import { toast } from "react-toastify"
import moment from "moment"

const dataInicial = {
    reunionesCientificas: [],
    loadingReuniones: false,
    creacion: '',
    creacionId: ''
}

const LOADING_REUNIONES_CIENTIFICAS = 'LOADING_REUNIONES_CIENTIFICAS'
const REUNIONES_CIENTIFICAS = 'REUNIONES_CIENTIFICAS'
const REUNIONES_CIENTIFICAS_ERROR = 'REUNIONES_CIENTIFICAS_ERROR'

const CREAR_REUNION_EXITO = 'CREAR_REUNION_EXITO'
const CREAR_REUNION_ERROR = 'CREAR_REUNION_ERROR'

//Reducers
export default function cientificasReducer(state = dataInicial, action) {
    switch (action.type) {
        case REUNIONES_CIENTIFICAS:
            return { ...state, reunionesCientificas: action.payload, loadingReuniones: action.loadingReuniones }
        case LOADING_REUNIONES_CIENTIFICAS:
            return { ...state, loadingReuniones: action.loadingReuniones }
        case CREAR_REUNION_EXITO:
            return { ...state, creacionId: action.payload, creacion: action.creacion }
        default:
            return { ...state }
    }
}

export const reuniones = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_REUNIONES_CIENTIFICAS,
        loadingReuniones: true
    })

    try {
        var entidad = "new_reunioncientficas"
        var fetch =
        "<entity name='new_reunioncientfica'>"+
        "<attribute name='new_name'/>"+
        "<attribute name='new_lugar'/>"+
        "<attribute name='new_formadeparticipacin'/>"+
        "<attribute name='new_fecha'/>"+
        "<attribute name='new_evento'/>"+
        "<attribute name='new_reunioncientficaid'/>"+
        "<order attribute='new_fecha' descending='true'/>"+
        "<filter type='and'>"+
        "<condition attribute='statecode' operator='eq' value='0'/>"+
        "</filter>"+
        "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='aa'>"+
        "<filter type='and'>"+
        "<condition attribute='new_correoelectronico' operator='like' value='"+usuarioPortal+"'/>"+
        "</filter>"+
        "</link-entity>"+
        "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: REUNIONES_CIENTIFICAS,
            payload: response.data,
            loadingReuniones: false
        })
    }
    catch (error) {
        dispatch({
            type: REUNIONES_CIENTIFICAS_ERROR,
            loadingReuniones: false
        })
    }
}

export const crearReunion = (empleado, objeto, token) => async (dispatch) => {
    const { new_name, new_evento, new_lugar, new_formadeparticipacin, new_fecha } = objeto;
    var fecha = new_fecha

    return toast.promise(
        new Promise((resolve, reject) => {
            axios.post(
                `${UrlApi}api/hrfactors/reunioncientifico`,
                {
                    "new_name": new_name,
                    "new_evento": new_evento,
                    "new_lugar": new_lugar,
                    "new_formadeparticipacin": new_formadeparticipacin,
                    "new_fecha": moment(fecha).format('YYYY-MM-DD'),
                    "new_empleado": empleado
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    dispatch({
                        type: CREAR_REUNION_EXITO,
                        payload: response.data,
                        creacion: "EXITO",
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);

                    dispatch({
                        type: CREAR_REUNION_ERROR,
                        creacion: "ERROR",
                    });
                    reject(error);
                });
        }),
        {
            pending: "Procesando...",
            success: "Participación creada con éxito!",
            error: {
                render({ data }) {
                    return `${data}`;
                },
            },
        },
        {
            theme: "dark",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    )
};